<template>
  <div>
    <Header title="免听申请"></Header>
    <div class="freeApplyIndex">
      <div class="applyList">
        <NOdata
          v-if="this.list && this.list.length == 0"
          title="未查询到免听申请信息"
        ></NOdata>
        <div v-else class="list">
          <div
            class="list-item info"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="content">
              <p>{{ item.kcmc }}[{{ item.kch }}]</p>
              <ul>
                <li>学年学期：{{ item.xqmc }}</li>
                <li>课程时间：{{ item.kcsj }}</li>
              </ul>
              <span
                :class="
                  item.shztmc == '审核中'
                    ? 'shzClass'
                    : item.shztmc == '待送审'
                    ? 'dssClass'
                    : item.shztmc == '审核通过'
                    ? 'ytgClass'
                    : 'btgClass'
                "
              >
                {{ item.shztmc }}
              </span>
            </div>
            <div class="operate">
              <span
                @click="select(item)"
                v-if="item.shztmc == '审核中' || item.shztmc == '通过'"
                class="sqClass"
              >
                查看
              </span>
              <span
                @click="apply(item)"
                v-if="
                  item.shztmc == '待送审' ||
                    item.shztmc == '不通过' ||
                    item.shztmc == '撤销' ||
                    item.shztmc == '未申请'
                "
                class="sqClass"
              >
                申请
              </span>
              <span
                @click="reback(item)"
                v-if="
                  (item.id != '' && item.shztmc != '通过') ||
                    (item.shztmc == '通过' && shtgxskcx == 1)
                "
                class="rebackClass"
                >撤销</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";

export default {
  data() {
    return {
      list: [],
      shtgxskcx: ""
    };
  },
  methods: {
    select(item) {
      item.ck='1'
      this.$router.push({
        path: "/freeApply/apply",
        query: {
          list: item
        }
      });
    },
    apply(item) {
      this.$router.push({
        path: "/freeApply/apply",
        query: {
          list: item
        }
      });
    },
    async reback(item) {
      const res = await Api.cxmtsq({
        id: item.id
      });
      if (res.code == 1) {
        this.$toast.success("撤销成功!");
        setTimeout(() => {
          this.getList();
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    async getList() {
      const res = await Api.mtsqKclist();
      this.list = res.data.kclist;
      this.shtgxskcx = res.shtgxskcx;
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.delete-button {
  height: 100%;
}
.freeApplyIndex {
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: #212f6e !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #8f95b5;
      letter-spacing: 0;
    }
    .van-tabs__line {
      background-color: #7469f8 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
  .applyList {
    padding: 5% 5% 0;
    .van-search {
      padding: 0;
      height: 44px;
      background: #f4f5ff;
      border-radius: 3px;
      margin-bottom: 5%;
    }
    .van-search .van-cell,
    .van-search__content,
    .van-field__control {
      background: #f4f5ff;
    }

    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #757da3 !important;
      letter-spacing: 0;
    }

    .list-head {
      height: 80px;
      background-image: url("../../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding: 6% 7%;
      box-sizing: border-box;
      margin-bottom: 5%;

      div {
        width: 50%;
        height: 100%;
        p {
          font-size: 12px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        span {
          display: flex;
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 70%;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
    .list {
      padding-bottom: 55px;
      overflow: auto;
      .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        position: relative;
        .content {
          padding: 3% 6% 3% 6%;
          p {
            width: 80%;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #212f6e;
            letter-spacing: 0;
            margin-bottom: 2%;
          }
          ul li {
            font-family: PingFangSC-Light;
            font-size: 12px;
            color: #757da3;
            letter-spacing: 0;
            margin-bottom: 1%;
            width: 80%;
          }
          span {
            width: 70px;
            height: 42px;
            border-radius: 5px;
            position: absolute;
            top: calc(50% - 25px);
            right: 5%;
            font-weight: bold;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 15px;
          }
          .shzClass {
            color: #7469f8;
          }
          .btgClass {
            color: #f86969;
          }
          .ytgClass {
            color: #12ddd6;
          }
          .dssClass {
            color: #757da3;
          }
        }
      }
    }
  }
  .info {
    .operate {
      border-top: 1px solid #dee1e9;
      display: block;
      height: 40px;
      line-height: 40px;
      display: flex;
      width: 100%;
      background-color: #ecedfd;
      box-sizing: border-box;
      border-radius: 0 0 5px 5px;
      .rebackClass {
        color: #7469f8;
      }
      .sqClass {
        color: #7469f8;
      }
      .disClass {
        color: gray;
        background-color: #f8f8f8;
      }
      span {
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #212f6e;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
        &:last-child {
          border-left: 1px solid #dee1e9;
        }
        &:nth-child(2) {
          border-left: 1px solid #dee1e9;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/freeApply/index.vue